import React from 'react';
import { SvgIcon } from './svg-icon';

export const File = props => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    <path d="M13.5 2.25H6.375C5.33944 2.25 4.5 3.08944 4.5 4.125V19.875C4.5 20.9106 5.33944 21.75 6.375 21.75H17.625C18.6606 21.75 19.5 20.9106 19.5 19.875V8.25L13.5 2.25ZM12.75 9V3.75L18 9H12.75Z" />
  </SvgIcon>
);
